<template>
    <ion-page class="ion-page"  id="main">
        <default-header>
            <template v-slot:start>
                <ion-buttons slot="start">
                    <ion-back-button :text="$t('ncrypt.back')"/>
                </ion-buttons>
            </template>

            <template>
                <ion-title>{{ draft.sent_at }}</ion-title>
            </template>
        </default-header>

        <ion-content fullscreen>
            <ion-chip>
                <ion-avatar>
                    <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjYzVkYmZmIiBkPSJNMCAwaDUxMnY1MTJIMHoiLz48cGF0aCBkPSJNMjU2IDMwNGM2MS42IDAgMTEyLTUwLjQgMTEyLTExMlMzMTcuNiA4MCAyNTYgODBzLTExMiA1MC40LTExMiAxMTIgNTAuNCAxMTIgMTEyIDExMnptMCA0MGMtNzQuMiAwLTIyNCAzNy44LTIyNCAxMTJ2NTZoNDQ4di01NmMwLTc0LjItMTQ5LjgtMTEyLTIyNC0xMTJ6IiBmaWxsPSIjODJhZWZmIi8+PC9zdmc+"
                         alt="">
                </ion-avatar>

                <ion-label>Afzender naam</ion-label>
            </ion-chip>

            <ion-card>
                <ion-card-header>
                    <ion-card-title>{{ draft.subject }}</ion-card-title>
                </ion-card-header>

                <ion-card-content v-html="draft.body"/>
            </ion-card>
            <div data-todo-make-into-component>
                <ion-chip>
                    <ion-icon ios='attach' md="attach"/>
                    <ion-label>Holiday.jpg</ion-label>
                </ion-chip>

                <ion-chip>
                    <ion-icon ios='attach' md="attach"/>
                    <ion-label>Data.xml</ion-label>
                </ion-chip>
            </div>

            <ion-fab-button class="page-action" @click="presentActionSheet">
                <ion-icon md="ellipsis-vertical" slot="ellipsis-vertical"/>
            </ion-fab-button>
        </ion-content>
    </ion-page>
</template>

<script>
    import DefaultHeader from "../../nav/DefaultHeader.vue";
    export default {
        components: {DefaultHeader},
        data() {
            return {
                draft: [],
            }
        },
        methods: {
            retrieveDraft() {
                this.$http
                    .get('/drafts/' + this.$route.params.id)
                    .then(response => this.draft = response.data)
                    .catch(error => window.console.error(error));
            },
            async presentActionSheet() {
                const actionSheet = await this.$ionic.actionSheetController.create({
                    header: 'Acties',
                    buttons: [
                        {
                            text: 'Verwijderen',
                            role: 'destructive',
                            name: 'trash',
                            handler: () => {
                                window.console.log('Delete clicked')
                            },
                        },
                        {
                            text: 'Versturen',
                            icon: 'send',
                            handler: () => {
                                window.console.log('Send clicked')
                            },
                        },
                        {
                            text: 'Bewerken',
                            icon: 'create',
                            handler: () => {
                                window.console.log('Edit clicked')
                            },
                        },
                        {
                            text: 'Cancel',
                            icon: 'close',
                            role: 'cancel',
                            handler: () => {
                                window.console.log('Cancel clicked')
                            },
                        },
                    ],
                });
                actionSheet.present();
            },
        },
        created() {
            this.retrieveDraft();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
